// /components/CookieBanner/CookieBanner.jsx
import './CookieBanner.css';
import {useEffect, useMemo, useState} from "react";
import CookieOption from "./sub/CookieOption/CookieOption.jsx";
import {useCookies} from "../../context/CookiesContext/CookiesContext.jsx";
import {useMediaQuery} from "react-responsive";

export default function CookieBanner() {
    const { decided, prefs, acceptAll, savePreferences } = useCookies();
    const [displayPersonalization, setDisplayPersonalization] = useState(false);
    const isMobile = useMediaQuery({maxWidth: 768});

    // lokalny stan "roboczy" dla ekranu ustawień
    const [draft, setDraft] = useState(prefs);

    useEffect(() => {
        setDraft(prefs);
    }, [prefs, displayPersonalization]);

    const options = useMemo(() => ([
        {
            key: 'required',
            title: "Ciasteczka niezbędne do działania strony",
            text: "Są konieczne, aby nasza strona funkcjonowała prawidłowo – z nich nie możesz zrezygnować. Dzięki nim dbamy o bezpieczeństwo oraz szybkie wykrywanie i naprawianie błędów.",
            blocked: true
        },
        {
            key: 'analytic',
            title: "Ciasteczka analityczne – poznajemy Twoje potrzeby",
            text: "Pozwalają nam lepiej zrozumieć, jak korzystasz ze strony: jak często ją odwiedzasz, jak długo ją przeglądasz czy które sekcje są dla Ciebie najciekawsze. Dzięki tym danym możemy ulepszać serwis i rozwijać ofertę zgodnie z Twoimi oczekiwaniami.",
            blocked: false
        },
        {
            key: 'advertisement',
            title: "Ciasteczka reklamowe – dopasujemy do Ciebie reklamy",
            text: "Na podstawie Twojej aktywności analizujemy, jakie treści i produkty mogą Cię zainteresować. Dzięki temu wyświetlamy reklamy, które są bardziej trafne i użyteczne.",
            blocked: false
        },
        {
            key: 'personalization',
            title: "Ciasteczka personalizujące stronę",
            text: "Umożliwiają dostosowanie wyglądu i treści serwisu do Twoich preferencji. To dzięki nim widzisz materiały, które najlepiej odpowiadają Twoim zainteresowaniom i potrzebom zakupowym.",
            blocked: false
        }
    ]), []);

    if (decided) return null;

    return (
        <div id='cookie-banner-overlay' aria-modal="true" role="dialog">
            <div
                id='cookie-banner'
                style={{
                    width: isMobile ? '90%' : '30em',
                    height: isMobile ? displayPersonalization ? '85%' : '40%' : displayPersonalization ? '85%' : '20em'
                }}
            >
                {!displayPersonalization ? (
                    <>
                        <div id="cookie-banner-top">
                            <img src="/images/cookie-icon.webp" alt="Obrazek ciasteczka" loading='lazy' id='cookie-banner-image'/>
                        </div>
                        <div id="cookie-banner-mid">
                            <h2><strong>LumeStore używa ciasteczek</strong></h2>
                            <h4>
                                Używamy plików cookie, aby personalizować naszą stronę i ofertę zgodnie z Twoimi zainteresowaniami
                                oraz w celach pomiarowych i analitycznych. Zdecyduj, na co się zgadzasz.
                            </h4>
                        </div>
                        <div id="cookie-banner-bottom">
                            <div className="cookie-banner-bttn" id='accept-bttn' onClick={acceptAll}>
                                Zaakceptuj wszystkie
                            </div>
                            <div
                                className="cookie-banner-bttn"
                                id='configure-bttn'
                                onClick={() => setDisplayPersonalization(true)}
                            >
                                Personalizuj ciasteczka
                            </div>
                        </div>
                    </>
                ) : (
                    <div id='cookies-banner-settings'>
                        <h1><strong>Ustawienia ciasteczek</strong></h1>
                        <h4>
                            Możesz samodzielnie zdecydować, jakie dane udostępniasz i w jakim celu.
                            Niektóre cookies są niezbędne, inne opcjonalne – wybór zawsze należy do Ciebie.
                        </h4>
                        <div id='cookies-banner-settings-container'>
                            {options.map(opt => (
                                <CookieOption
                                    key={opt.key}
                                    title={opt.title}
                                    text={opt.text}
                                    blocked={opt.blocked}
                                    checked={!!draft[opt.key]}
                                    onToggle={() => {
                                        if (opt.blocked) return;
                                        setDraft(d => ({...d, [opt.key]: !d[opt.key]}));
                                    }}
                                />
                            ))}
                        </div>
                        <div id='cookies-banner-settings-bttns-container'>
                            <div
                                id='cookies-banner-settings-save-bttn'
                                className='cookie-banner-bttn'
                                onClick={() => {
                                    // wymagane zawsze true
                                    const toSave = {...draft, required: true};
                                    savePreferences(toSave);
                                    setDisplayPersonalization(false);
                                }}
                            >
                                Zapisz ustawienia
                            </div>
                            <div
                                id='cookies-banner-settings-accept-all-bttn'
                                className='cookie-banner-bttn'
                                onClick={() => {
                                    // all true
                                    savePreferences({
                                        required: true,
                                        analytic: true,
                                        advertisement: true,
                                        personalization: true
                                    });
                                    setDisplayPersonalization(false);
                                }}
                            >
                                Zaakceptuj wszystko
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
